<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading"
           :width="720"
           @on-cancel="cancel"
    >
      <h3 slot="header" class="modal-header">新增枚举值配置</h3>
      <section style="padding-bottom: 60px">
        <Form :label-width=100 class="mb16">

          <FormItem class="notip ivu-form-item-required" label="元数据名称"
                    style="align-items: center"
                    label-position="left"
          >
            <Select size="small" style="width: 120px;" v-model="enumKey" @on-change="changeKey">
              <Option value="">请选择</Option>
              <Option v-for="(item,index) in metaList" :value="item.enumKey" :key="'keyA'+index">{{item.enumName}}
              </Option>

            </Select>
            <Button style="margin-left: 20px" type="primary" size="small" @click.stop="add">添加</Button>
          </FormItem>
        </Form>


        <div v-if="chooseType===2" class="notip">
          <!--          :rules="singleRule"-->

          <Form :label-width=60 v-for="(item,index) in list" style="width: 100%;"
                inline :key="'keyV'+index"
                :rules="ruleRange"
                :ref="'form'+index"
                :model="item"
          >
            <FormItem :label="metaListMap[enumKey + ''].title" class="notip" prop="key"  v-if="metaListMap[enumKey + ''].title">
              <Select size="small" class="formwidth" v-model="item.key">
                <Option value="">请选择</Option>
                <Option v-for="(item,index) in metaListMap[enumKey+''].extList" :value="item.value"
                        :key="'keyB'+index">{{item.key}}
                </Option>
              </Select>
            </FormItem>

            <FormItem label="最小值" class="notip" prop="begin">
              <InputNumber :min="-100" :max="101" v-model="item.begin" size="small" class="inputwidth"></InputNumber>
            </FormItem>
            <FormItem label="最大值" class="notip" prop="end">
              <InputNumber :min="-100" :max="101" v-model="item.end" size="small"></InputNumber>
            </FormItem>
            <FormItem label="系数" class="notip" prop="value">
              <InputNumber v-model="item.value" size="small" :min="0" :max="10"></InputNumber>
<!--              <Button size="small" style="margin-left: 30px" @click.stop="deleteItem(index)" v-if="index!==0">删除</Button>-->

            </FormItem>
            <FormItem label="备注" class="notip" >
              <Input v-model="item.title" size="small" class="inputwidth"></Input>
              <Button size="small" style="margin-left: 30px" @click.stop="deleteItem(index)" v-if="index!==0">删除</Button>
            </FormItem>


          </Form>

        </div>
        <div v-if="chooseType===1">
          <div v-for="(item,index) in list"  :key="'keyG'+index">

            <Form :label-width=60
                  inline
                  :rules="ruleSingle"
                  :ref="'form'+index"
                  :model="item"
            >
              <FormItem :label="metaListMap[enumKey + ''].title" class="notip" prop="key" v-if="metaListMap[enumKey + ''].title">
                <Select size="small" class="formwidth" v-model="item.key">
                  <Option v-for="(item1,index1) in metaListMap[enumKey+''].extList"
                          :value="item1.value"
                          :key="'keyB'+index1">{{item1.text}}
                  </Option>
                </Select>
              </FormItem>
              <FormItem label="系数" class="notip" prop="value">
                <InputNumber size="small" v-model="item.value" :min="0" :max="10"></InputNumber>
                <Button size="small" style="margin-left: 30px" @click.stop="deleteItem(index)" v-if="index!==0">删除</Button>
              </FormItem>
            </Form>
          </div>

        </div>
      </section>
    </Modal>
  </div>


</template>
<script>
  import {saveMeta} from "../../../../../api/meta";
  import {deepClone} from "../../../../../utils/format";

  export default {
    name: "",
    props: {
      n: {
        type: Number,
        default: 0
      },
      metaList: {
        type: Array,
        defalut: () => {
          return []
        }
      }
    },
    computed: {

      metaListMap() {
        let ret = {}
        this.metaList.forEach(item => {
          ret[item.enumKey + ''] = item
        })
        return ret
      },
      chooseType() {
        if (!this.enumKey || !this.metaListMap[this.enumKey + '']) {
          return null

        }
        return this.metaListMap[this.enumKey + ''].enumType


      },
      itemData() {
        if (!(this.enumKey + '')) {
          return null
        }
        // 枚举类型 0-非枚举，1-单值，2-范围值
        if (this.chooseType === 1) {
          return {
            title: '',
            key: null,
            value: null
          }
        }

        if (this.chooseType === 2) {
          return {
            title: '',
            key: null,
            value: null,
            begin: null,
            end: null
          }
        }
        return null

      },
    },
    watch: {
      n() {
        this.enumKey = ''
        this.list = []
        this.isShow = true
      }
    },
    data() {
      return {
        loading: true,
        isShow: false,
        singleRule: {},
        enumKey: '',
        list: [],
        ruleRange: {
          key: [{required: true, message: ' ', trigger: 'change', type: 'string'}],
          value: [{required: true, message: ' ', trigger: 'blur', type: 'number'}],
          begin: [{required: true, message: ' ', trigger: 'blur', type: 'number'}],
          end: [{required: true, message: ' ', trigger: 'blur', type: 'number'}]

        },
        ruleSingle: {
          key: [{required: true, message: ' ', trigger: 'change', type: 'string'}],
          value: [{required: true, message: ' ', trigger: 'blur', type: 'number'}],
        },

      }
    },
    methods: {
      changeKey(){
        this.list=[]
        this.list.push(deepClone(this.itemData))

      },
      deleteItem(index) {
        this.list.splice(index, 1)

      },
      saveMeta() {
        console.log('save----')

        if(this.chooseType===1){
        if (this.metaListMap[this.enumKey + ''] && this.metaListMap[this.enumKey + ''].title) {
          let map = {}
          this.metaListMap[this.enumKey + ''].extList.forEach(ele => {
            map[ele.value + ''] = ele.text
          })
          this.list.forEach(ele => {
            ele['title'] = map[ele.key + '']
          })
        }
        }



        let params = {
          orgMetaRelFid: this.metaListMap[this.enumKey + ''].orgMetaRelFid,
          enumKey: this.enumKey,
          enumValueList: this.list,
          enumType: this.chooseType
        }
        saveMeta(params).then(res => {
          this.$emit('done')
          this.$Message.success('保存成功')

        }).catch(error => {
          // this.$Message.info('保存失败')
        }).finally(() => {
          this.isShow = false
        })

      },
      add() {
        if (!(this.enumKey + '')) {
          this.$Message.info('请先选择元数据')
          return
        }
        this.list.push(deepClone(this.itemData))
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {

        if(!this.enumKey || !this.list.length){
          this.$Message.info('请添加元数据配置')
          this.changeLoading()
          return

        }
        let validate = true
        for (let i in this.$refs) {
          this.$refs[i].forEach(item => {
            item.validate(bool => {
              !bool && (validate = bool)
            })
          })
        }
        if (!validate) {
          this.changeLoading()
          return
        }

        this.saveMeta()
      },
      cancel() {

      }
    }

  }
</script>

<style scoped>
  .formwidth {
    width: 100px;
    display: inline-block;
  }

  .inputwidth {
    width: 80px;
  }

</style>
